import { i18n } from 'invision-core';
import moment from 'moment';
import LocaleKeys from '../locales/keys';
export var formatCardName = function formatCardName(cardTypes, cardType, accountNumber) {
  var substitution = {
    cardType: findCardType(cardTypes, cardType),
    last4Digits: accountNumber ? accountNumber.slice(-4) : ''
  };
  return i18n.translate(LocaleKeys.MAKE_PAYMENT.CARD_TYPE_AND_LAST_FOUR, substitution);
};
export var findCardType = function findCardType(cardTypes, cardType) {
  var type = cardType ? cardTypes.find(function (item) {
    return String(item.Value) === String(cardType);
  }) : null;
  return type ? type.Name : null;
};
export var formatExpirationDate = function formatExpirationDate(creditCard) {
  var substitution = {
    expirationMonth: creditCard.expirationMonth,
    expirationYear: creditCard.expirationYear
  };
  return i18n.translate(LocaleKeys.CREDIT_CARD_EXPIRATION_DATE, substitution);
};
export var formattedCreditCardExpiration = function formattedCreditCardExpiration(paymentMethod) {
  if (!paymentMethod.CreditCard) {
    return '';
  }
  var _paymentMethod$Credit = paymentMethod.CreditCard,
    ExpirationMonth = _paymentMethod$Credit.ExpirationMonth,
    ExpirationYear = _paymentMethod$Credit.ExpirationYear;
  return "".concat(ExpirationMonth, "/").concat(ExpirationYear);
};
export var isExpired = function isExpired(payment) {
  var formattedExpiration = formattedCreditCardExpiration(payment);
  if (formattedExpiration.length) {
    return moment(formattedExpiration, 'MM/YYYY').isBefore(moment(), 'month');
  }
  return false;
};